export enum statusCodeEnum {
    Scheduled = '0001',
    InProgress = '0002',
    Completed = '0003',
    Canceled = '0004',
}
